import { Box, Heading } from '@chakra-ui/react';

import styles from './labeled-group.module.css';

export const LabeledGroup = ({
  children,
  groupName,
}: {
  groupName: string;
  children: React.ReactNode;
}) => {
  return (
    <fieldset className={styles['columnFieldSet']}>
      <legend className={styles['columnFieldSetHeading']}>
        <Heading fontWeight="600" size="xs" color="gray.500">
          {groupName}
        </Heading>
      </legend>
      <Box>{children}</Box>
    </fieldset>
  );
};
